import { useEffect } from "react";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { Button, Flex, Text } from "@paguelofacil/pf-components";

import { language, languageDefault } from "../services/utils/Language";
import { maxLength12 } from "../services/utils/Validations";
import { useLoginConfirmationCode } from "../hooks/useLoginConfirmationCode";

import { InputText } from "./Inputs/Text";

const ValidateCode = ({ setIsLoading, handleChangeForm, valuesForm }) => {
    const { isLoadingConfirmationCode, loginConfirmationCodeCryptofacil } = useLoginConfirmationCode();

    const onResendCode = () => {
        setIsLoading(true);

        console.log("reenviar codigo de validacion");

        setIsLoading(false);
    };

    const handleSubmit = async e => {
        setIsLoading(true);
        e.preventDefault();
        try {
            await loginConfirmationCodeCryptofacil(valuesForm.validationCode, valuesForm.email);
            console.log("validar codigo e iniciar sesion", valuesForm);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const shouldDisabledButtonNext = !valuesForm.validationCode;

    useEffect(() => {
        setIsLoading(isLoadingConfirmationCode);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingConfirmationCode]);

    return (
        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
            <Flex gap="1.25rem" direction="column">
                <InputText
                    label={
                        <FormattedMessage
                            id={language.validation_code}
                            defaultMessage={languageDefault.validation_code}
                        />
                    }
                    name="validationCode"
                    placeholder="000000000000"
                    onChangeValue={value => handleChangeForm("validationCode", value)}
                    validation={maxLength12}
                    isRequired={true}
                />
                <Text
                    variant="caption"
                    weight="regular"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <FormattedMessage
                        id={language.not_get_verification_code}
                        defaultMessage={languageDefault.not_get_verification_code}
                    />
                    &nbsp;
                    <Button variant="link" handleClick={onResendCode} style={{ color: "#378FA2" }}>
                        <FormattedMessage id={language.resend} defaultMessage={languageDefault.resend} />
                    </Button>
                </Text>
                <Button
                    className="button-primary-cf"
                    fullWidth
                    size="md"
                    type="submit"
                    style={{ marginTop: "1.25rem" }}
                    disabled={shouldDisabledButtonNext}
                >
                    <FormattedMessage id={language.validate_email} defaultMessage={languageDefault.validate_email} />
                </Button>
            </Flex>
        </form>
    );
};

export default ValidateCode;
